<template>
  <v-container fluid>

    <PageTitle icon="fal fa-fw fa-bullhorn">
      Send Campaign
    </PageTitle>

    <email-campaign-stepper>
    </email-campaign-stepper>

    <router-view>
    </router-view>
  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import EmailCampaignStepper from './components/Stepper';
import EmailCampaignTemplate from './Template';
import EmailCampaignRecipients from './Recipients';
import EmailCampaignReview from './Review';
import PageTitle from '../../../components/PageTitle.vue';

export default {
  components: {PageTitle, EmailCampaignReview, EmailCampaignRecipients, EmailCampaignTemplate, EmailCampaignStepper},
  data() {
    return {}
  },
  computed: {
    ...mapGetters([
      'isEmailComposerEnabled', // MLD-6403
      'team',
    ]),
    ...mapGetters('emailCampaignCart', [
      'step',
    ]),
  },
  created() {
    if (this.isEmailComposerEnabled) { // MLD-6403
      this.$router.replace({name: `${this.$root.routePrefix}.send.email`, query: this.$route.query});
    } else {
      this.$store.dispatch('emailCampaignCart/reset');
    }
  },
}
</script>
